import React, { useEffect, useState, useRef } from "react";
import "./list.css";
import SectionHeader from "../sectionHeader/sectionHeader";
import { getPlaylist, getAWSUrl, getYoutubePlaylist } from "../api/core";
import Anchor from "../Link/anchor";
import { Link } from "react-router-dom";
import LazyImg from "../lazy/lazy";
import Icon from "../icon/icon";
import { BORDER, VCMS } from "../../global";

const List = (props) => {
  const mounted = useRef(false);
  const init = { playlist: [] };
  const y_init = { items: [] };
  const [nlselem, setNLSElem] = useState([]);
  const [nlselemItem, setNLSItem] = useState([]);
  const [nlsplaylist, setNLSPlaylist] = useState(
    VCMS === "YouTube" ? y_init : init
  );
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [nlselemdisplay, setNLSElemDisplay] = useState(true);
  /* eslint-disable no-unused-vars */
  const [desc, setDesc] = useState(false);
  const [news, setNews] = useState(false);
  /* eslint-disable no-unused-vars */
  const [nviewlsAll, setNViewlsAll] = useState("");
  const [nviewlsLink, setNviewlsLink] = useState("");

  useEffect(() => {
    mounted.current = true;
    const NLSElemDetail = async () => {
      /* eslint-disable no-unused-vars */
      if (mounted.current) {
        setNLSElem(props.tabbed ? props.tabid : props.information);
        setNLSElemDisplay(
          props.tabbed
            ? props.tabid.devices[0].itemVisibility
            : props.information.devices[0].itemVisibility
        );
        setNLSItem(props.tabbed ? props.tabid.items : props.information.items);

        if (!props.tabbed) {
          if (
            props.information.playlistId !== null &&
            props.information.playlistId !== ""
          ) {
            NLSplaylistDetail(
              props.information.playlistId,
              props.information.devices[0].itemSize
            );
          }
          props.information.displayNameVisibility === "On Hover" ||
          props.information.displayNameVisibility === "Show Always"
            ? setDesc(true)
            : setDesc(false);
          props.information.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.information.viewAllVisibility === true &&
          props.information.viewAllText !== null
            ? setNViewlsAll(props.information.viewAllText)
            : setNViewlsAll("");
          if (
            props.information.viewAllVisibility === true &&
            props.information.viewAllPage !== null
          ) {
            const link =
              props.information.viewAllPage.pageType === "externalPage"
                ? props.information.viewAllPage.externalPage
                : props.information.viewAllPage.pageType === "internalPage"
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.internalPage
                : props.information.viewAllPage.urlName !== ""
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.urlName
                : "/" +
                  props.match.params.AppId +
                  "/page/" +
                  props.information.viewAllPage._id;
            setNviewlsLink(link);
          }
        } else {
          if (
            props.tabid.playlistId !== null &&
            props.tabid.playlistId !== ""
          ) {
            NLSplaylistDetail(
              props.tabid.playlistId,
              props.tabid.devices[0].itemSize
            );
          }
          props.tabid.displayNameVisibility === "On Hover" ||
          props.tabid.displayNameVisibility === "Show Always"
            ? setDesc(true)
            : setDesc(false);
          props.tabid.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.tabid.viewAllVisibility === true &&
          props.tabid.viewAllText !== null
            ? setNViewlsAll(props.tabid.viewAllText)
            : setNViewlsAll("");
          if (
            props.tabid.viewAllVisibility === true &&
            props.tabid.viewAllPage !== null
          ) {
            const link =
              props.tabid.viewAllPage.pageType === "externalPage"
                ? props.tabid.viewAllPage.externalPage
                : props.tabid.viewAllPage.pageType === "internalPage"
                ? props.tabid.viewAllPage.internalPage
                : "/" +
                  props.match.params.AppId +
                  "/" +
                  props.tabid.viewAllPage.pageType +
                  "/" +
                  props.tabid.viewAllPage._id;
            setNviewlsLink(link);
          }
        }
      }

      /* eslint-disable no-unused-vars */
    };

    const NLSplaylistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */

      if (VCMS === "YouTube" && id) {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setNLSPlaylist(result.data);
            }
          },
          (error) => {
            SetError(true);
          }
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setNLSPlaylist(result.data);
            }
          },
          (error) => {
            SetError(true);
          }
        );
      }

      /* eslint-disable no-unused-vars */
    };

    NLSElemDetail();
    isLoading(false);
    return () => {
      mounted.current = false;
    };
  }, [props.information, props.match.params.AppId, props.tabid, props.tabbed]);

  if (nlselemdisplay && !error && !loading) {
    return (
      <div>
        <SectionHeader
          title={nlselem.displayName}
          linkTitle={nviewlsAll}
          link={nviewlsLink}
          header={props.header}
        ></SectionHeader>
        <div className="listContainer">
          <div className="row">
            {nlselemItem !== null
              ? nlselemItem.map((item, index) =>
                  item.itemid.devices[0].itemVisibility ? (
                    <div
                      key={index}
                      className={
                        props.single
                          ? "col-xs-12 col-lg-12"
                          : "col-xs-12 col-lg-6"
                      }
                    >
                      <div className="post-content media">
                        <Anchor
                          to={
                            item.itemid.pageType === "externalPage"
                              ? item.itemid.externalPage
                              : item.itemid.pageType === "internalPage"
                              ? item.itemid.internalPage
                              : item.itemid.pageType === "videoPage"
                              ? props.match.params.AppId +
                                "/" +
                                item.itemid.pageType +
                                "/" +
                                item.itemid.videoId
                              : "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.urlName !==
                                ""
                              ? item.itemid.urlName
                              : item.itemid.pageType + "/" + item.itemid._id
                          }
                        >
                          <LazyImg
                            className={BORDER ? "d-flex" : "d-flex no-border"}
                            src={
                              item.itemid.bannerImage
                                ? getAWSUrl() + item.itemid.bannerImage.imagekey
                                : ""
                            }
                            alt=""
                            orient={"landscape"}
                          />
                        </Anchor>
                        <div
                          className={
                            props.single
                              ? "media-body align-self-center single"
                              : "media-body align-self-center"
                          }
                        >
                          <h3 className="post-title">
                            <Anchor
                              to={
                                item.itemid.pageType === "externalPage"
                                  ? item.itemid.externalPage
                                  : item.itemid.pageType === "internalPage"
                                  ? item.itemid.internalPage
                                  : item.itemid.pageType === "videoPage"
                                  ? props.match.params.AppId +
                                    "/" +
                                    item.itemid.pageType +
                                    "/" +
                                    item.itemid.videoId
                                  : item.itemid.urlName !== ""
                                  ? "/" +
                                    props.match.params.AppId +
                                    "/" +
                                    item.itemid.urlName
                                  : item.itemid.pageType + "/" + item.itemid._id
                              }
                            >
                              {item.itemid.mainHeader !== null
                                ? item.itemid.mainHeader
                                : item.itemid.displayName}
                            </Anchor>
                          </h3>
                          <p className="post-date-info">
                            {item.itemid.introduction !== null
                              ? item.itemid.introduction
                              : item.itemid.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      key={index}
                      className="none"
                      style={{ display: "none" }}
                    ></div>
                  )
                )
              : ""}

            {VCMS === "YouTube"
              ? nlsplaylist.items !== undefined
                ? nlsplaylist.items.map((item, index) => (
                    <div
                      key={index}
                      className={
                        props.single
                          ? "col-xs-12 col-lg-12"
                          : "col-xs-12 col-lg-6"
                      }
                    >
                      <div className="post-content media">
                        <Link
                          to={
                            "/" +
                            props.match.params.AppId +
                            "/videoPage/" +
                            item.contentDetails.videoId
                          }
                        >
                          <LazyImg
                            className={BORDER ? "d-flex" : "d-flex no-border"}
                            src={item?.snippet.thumbnails.medium?.url}
                            orient={"landscape"}
                            alt=""
                          />
                        </Link>
                        <div
                          className={
                            props.single
                              ? "media-body align-self-center single"
                              : "media-body align-self-center"
                          }
                        >
                          <h3 className="post-title">
                            <Link
                              to={
                                "/" +
                                props.match.params.AppId +
                                "/videoPage/" +
                                item.contentDetails.videoId
                              }
                            >
                              {item.snippet.title}
                              {/* {item.ContentType==="Premium"?<Icon flag="transparent"></Icon>:""} */}
                            </Link>
                          </h3>
                          <p className="post-date-info">
                            {item.snippet.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                : ""
              : nlsplaylist.playlist !== undefined
              ? nlsplaylist.playlist.map((item, index) => (
                  <div
                    key={index}
                    className={
                      props.single
                        ? "col-xs-12 col-lg-12"
                        : "col-xs-12 col-lg-6"
                    }
                  >
                    <div className="post-content media">
                      <Link
                        to={
                          "/" +
                          props.match.params.AppId +
                          "/videoPage/" +
                          item.mediaid
                        }
                      >
                        <LazyImg
                          className={BORDER ? "d-flex" : "d-flex no-border"}
                          src={item.images[0].src}
                          orient={"landscape"}
                          alt=""
                        />
                      </Link>
                      <div
                        className={
                          props.single
                            ? "media-body align-self-center single"
                            : "media-body align-self-center"
                        }
                      >
                        <h3 className="post-title">
                          <Link
                            to={
                              "/" +
                              props.match.params.AppId +
                              "/videoPage/" +
                              item.mediaid
                            }
                          >
                            {item.title}
                            {item.ContentType === "Premium" ? (
                              <Icon flag="transparent"></Icon>
                            ) : (
                              ""
                            )}
                          </Link>
                        </h3>
                        <p className="post-date-info">{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))
              : ""}
          </div>
        </div>
      </div>
    );
  } else if (nlselemdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default List;
